import React from 'react'

const IndustryInput = React.createClass({
  componentDidMount: function() {
    this.onAutocomplete()
  },

  onAutocomplete: function() {
    SS.taskAutocomplete(`.keyword-${this.props.guId}`, this.props.handleSelectedItem)
  },

  render: function() {
    return(
      <input type="text"
        className={`form-control keyword-${this.props.guId}`}
        name="keyword"
        id={`keyword-${this.props.guId}`}
        placeholder={this.props.placeholder || 'Enter Industry'}
        defaultValue={this.props.keyword}
        onChange={this.props.handleItemChange}
        autoFocus
      />
    )
  }

})

export default IndustryInput
